import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import { Container, Menu, MenuItem } from '@mui/material';
import { useContext, useState } from 'react';

import CommentAPI from '../../../../../api/CommentAPI';
import {
    SessionContext,
    SessionContextType,
} from '../../../../../contexts/session';
import { Comment } from '../../../../../models/Comment';

import './PollCommentMenu.scss';
import ReportModal from '../../../ReportModal/ReportModal';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../../core/AppRouter/AppRouter';

interface PollCommentMenuProps {
    comment: Comment;
    comments: Comment[];
    setComments: React.Dispatch<React.SetStateAction<Comment[]>>;
}

const PollCommentMenu = (props: PollCommentMenuProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const openMenu = Boolean(anchorEl);
    const [openReport, setOpenReport] = useState<boolean>(false);
    const navigate = useNavigate();

    const onClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const onCloseHandler = () => {
        setAnchorEl(null);
    };

    const onDeleteHandler = async () => {
        const result = await CommentAPI.delete(props.comment.id, session);

        if (result === undefined) {
            props.setComments(
                props.comments.filter((comment) => {
                    return comment.id !== props.comment.id;
                }),
            );
        } else {
            console.error(JSON.stringify(result));
        }

        setAnchorEl(null);
    };

    const onReportHandler = () => {
        if (session.user) {
            setOpenReport(true);
        } else {
            navigate(`/${RoutePaths.SignIn}`);
        }
    };

    const reportActionHandler = async (reason: string): Promise<void> => {
        CommentAPI.createReport(
            props.comment.id,
            {
                reason,
            },
            session,
        );
        setOpenReport(false);
        setAnchorEl(null);
    };

    return (
        <Container className='poll-comment-menu-container'>
            <IconButton onClick={onClickHandler}>
                <MoreHorizIcon />
            </IconButton>
            <Menu
                className='poll-comment-menu'
                open={openMenu}
                anchorEl={anchorEl}
                onClose={onCloseHandler}
            >
                <MenuItem onClick={onReportHandler}>Report</MenuItem>
                {session.user?.id === props.comment.userId && (
                    <MenuItem onClick={onDeleteHandler}>Delete</MenuItem>
                )}
            </Menu>
            <ReportModal
                open={openReport}
                setOpen={setOpenReport}
                titleText='Report Comment'
                reportAction={reportActionHandler}
            />
        </Container>
    );
};

export default PollCommentMenu;
